<template>
  <div class="content-inner-wrapper">
    <div class="select_wrap">
      <div class="select_box left">
<!--      <template v-if="isInClubSystem">-->
<!--        <el-select-->
<!--          v-model="filterData.jixiaoType"-->
<!--          class="y-input"-->
<!--          clearable-->
<!--          placeholder=""-->
<!--          @change="changeQuery(true)"-->
<!--        >-->
<!--          <el-option label="全部评估类型" value=""></el-option>-->
<!--          <el-option-->
<!--            v-for="item in performanceGroupTypeList"-->
<!--            :key="item.value"-->
<!--            :label="item.label"-->
<!--            :value="item.value"-->
<!--          >-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </template>-->

      </div>
      <div class="select_box right">
        <input
          v-model.trim="filterData.stageName"
          type="text"
          class="yioks_input"
          style="width: 160px"
          placeholder="请输入关键字"
          @keyup.enter="changeQuery(true)"
        />
        <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
      </div>
    </div>
    <div class="list_wrap" v-if="!loading && !empty">
      <div class="table">
        <div class="thead">
          <div class="tr">
            <div class="th seq">序号</div>
            <div class="th stageName">申报评估考核阶段名称</div>
            <div class="th jixiaoType">评估对象</div>
            <div class="th open">状态</div>
            <div class="th description">描述信息</div>
            <div class="th action">操作</div>
          </div>
        </div>
        <div class="scrollArea">
          <vue-scroll>
            <div class="tbodyWrap">
              <div class="tbody">
                <div
                  class="tr"
                  v-for="(item, index) in stageList"
                  :key="item.uuid"
                >
                  <div class="td seq">
                    <p>{{ index + 1 }}</p>
                  </div>
                  <div class="td stageName">
                    <p :title="item.stageName">{{ item.stageName }}</p>
                  </div>
                  <div class="td jixiaoType">
                    <p>{{ item.jixiaoType | performanceTypeFilter }}</p>
                  </div>
                  <div class="td open">
                    <p>{{ item.open | booleanStatus }}</p>
                  </div>
                  <div class="td description">
                    <p :title="item.description">{{ item.description }}</p>
                  </div>
                  <div class="td action">
                    <p>
<!--                      <template v-if="isInClubSystem">-->
<!--   <span class="item" @click="handleDeviceRow(item)"-->
<!--                        >分配专家</span>-->
<!--                      </template>-->
<!--                      <template v-else>-->
<!--  <span class="item" @click="handleCheckDetails(item)"-->
<!--                        >查看</span>-->
<!--                      </template>-->
                      <template>
                        <span class="item" @click="handleDeviceRow(item)"
                        >分配专家</span>
                      </template>


                      <span class="split">/</span>
                      <span class="item" @click="handleEditRow(item)"
                        >编辑</span
                      >
                      <span class="split">/</span>
                      <span class="item" @click="handleDeleteRow(item)"
                        >删除</span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </vue-scroll>
        </div>
      </div>
    </div>

    <yioks-loading v-if="loading" />
    <yioks-empty
      v-if="empty"
      tips="暂时没有数据，"
      name="立即添加申报评估考核阶段"
      @callback="handleAddPerformanceGroup"
    ></yioks-empty>

    <template v-if="isShowAddDialog">
      <phase-dialog
        :isOpen="isShowAddDialog"
        :isEdit="isEditMode"
        :defaultInfo="editRow"
        :readOnly="readOnly"
        @closeGroupDialog="phaseDialogCallBack"
      ></phase-dialog>
    </template>
    <yioks-tips
      :showTip="deleteFlag"
      tipMsg="确认删除申报评估考核阶段吗？"
      :loading="repeatDelete"
      @callback="handleConfirmDelete"
    ></yioks-tips>
  </div>
</template>

<script>
import { performanceGroupTypeList } from "@/assets/js/yioksSelect";
import { getStageList, deleteStageList } from "@/api/performance";
import { performanceTypeFilter, booleanStatus } from "@/assets/js/yioksFilters";
import mixinAppConfig from "@/mixin/mixinAppConfig";
export default {
  mixins: [mixinAppConfig],
  props: {
    isShowAddDialog: {
      type: Boolean,
      default: false,
      required: false,
    },
    page: {
      type: Number,
      default: 0,
      required: false,
    },
    total: {
      type: Number,
      default: 0,
      required: false,
    },
    pageSize: {
      type: Number,
      default: 0,
      required: false,
    },
  },

  watch: {
    page() {
      this.changeQuery();
    },
  },

  components: {
    "phase-dialog": () => import("./PerformancePhaseDialog"),
    "yioks-tips": () => import("@/components/YioksTip"),
  },

  filters: {
    performanceTypeFilter,
    booleanStatus,
  },

  data() {
    return {
      empty: false,
      loading: false,
      filterData: {
        stageName: "",
        jixiaoType: '',
      },
      performanceGroupTypeList,
      isEditMode: false,
      editRow: {},
      deleteRow: {},
      deleteFlag: false,
      repeatDelete: false,
      // pageSize: 20, // 临时数据，需绑定Index.vue数据
      // page: 0,
      stageList: [],
      readOnly: false,
    };
  },

  mounted() {
    this.setSearchData();
    this.changeQuery();
  },

  methods: {
    handleSetAddDialog(flag) {
      this.$emit("update:isShowAddDialog", flag);
    },
    handleAddPerformanceGroup() {
      this.$emit("update:isShowAddDialog", true);
    },
    setSearchData() {
      const { page, stageName } = this.$route.query;
      stageName && this.$set(this.filterData, "stageName", stageName);
      page && (this.page = Number(page));
    },
    changeQuery(flag) {
      flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.fullpath,
        query: {
          ...this.$route.query,
          ...this.filterData,
          page: this.page,
        },
      });
      this.loadPageListData();
    },
    loadPageListData() {
      this.loading = true;
      this.empty = false;
      const { stageName, page,jixiaoType } = this.$route.query;
      const paramsData = {
        stageName,
        page: Number(page) || 0,
        size: this.pageSize,
        jixiaoType
      };
      getStageList(paramsData)
        .then((res) => {
          this.loading = false;
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          this.$emit("update:total", res.totalElements);
          this.empty = res.empty;
          this.stageList = res.content;
        })
        .catch((err) => {
          this.loading = false;
          this.empty = true;
          console.error("err", err);
        });
    },

    // 处理审核阶段 添加/编辑 回调方法
    phaseDialogCallBack(dialogStatus, okFlag) {
      if (okFlag) {
        this.changeQuery(true);
        this.handleSetAddDialog(dialogStatus);
      } else {
        // 取消操作
        this.handleSetAddDialog(false);
      }
      this.isEditMode = false;
      this.readOnly = false;
      this.editRow = {};
    },

    // 确认删除考核阶段
    handleConfirmDelete(ok) {
      if (ok) {
        const { uuid } = this.deleteRow;
        deleteStageList(uuid)
          .then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            this.$message.success("该申报评估考核阶段已删除成功！");
            this.deleteFlag = false;
            this.deleteRow = {};
            this.changeQuery(true);
          })
          .catch((err) => {
            console.error("err", err);
            this.deleteFlag = false;
          });
      } else {
        this.deleteRow = {};
      }
      this.deleteFlag = false;
    },

    // 查看详情
    handleCheckDetails(row) {
      this.editRow = row;
      this.isEditMode = true;
      this.handleSetAddDialog(true);
      this.readOnly = true;
    },

    // 编辑行
    handleEditRow(row) {
      this.editRow = row;
      this.readOnly = false;
      this.isEditMode = true;
      this.handleSetAddDialog(true);
    },

    // 删除行
    handleDeleteRow(row) {
      this.deleteRow = row;
      this.deleteFlag = true;
    },

    // 前往分配专家学校页面
    handleDeviceRow(row) {
      const { uuid } = row;
      this.$router.push({
        path: 'allocationExportsList',
        query: {
          stageUuid: uuid,
        }
      })
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        min-height 45px
        height: auto
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        min-height 49px
        height auto
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height inherit
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        // white-space nowrap
        // overflow hidden
        // text-overflow ellipsis
        white-space pre-line
        padding 3px 5px
        text-align: center
        line-height: 1.4em
        color $color_white
.seq
  width 6%
.stageName
  width 25%
.description
  width 25%
.jixiaoType
  width 16%
.open
  width 8%
.action
  width 21%
  .item
    cursor pointer
    user-select none
    color $green_color
  .split
    margin 0 5px
</style>

<style lang="stylus" >
.y-input
  input
    border-radius 0px !important
</style>
